import { useUser } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import api from '../api/axios';

export interface UserRole {
  isAuthor: boolean;
  isAdmin: boolean;
  authorId: string | null;
}

export const useUserRole = () => {
  const { user, isLoaded } = useUser();

  return useQuery({
    queryKey: ['user-role', user?.id],
    queryFn: async () => {
      try {
        const response = await api.get('/me');
        const userData = response.data;

        return {
          isAuthor: userData.isAuthor || false,
          isAdmin: !userData.isAuthor, // If not an author, they're an admin
          authorId: userData.authorId || null,
        };
      } catch (error) {
        // If there's an error, deny access
        return { isAuthor: false, isAdmin: false, authorId: null };
      }
    },
    enabled: isLoaded && !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry on error to avoid repeated failed requests
  });
};
